import PropTypes from 'prop-types';

export const propTypes = {
  contentFormatType: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    slug: PropTypes.string,
    description: PropTypes.string,
  }),
};

export const defaultProps = {
  contentFormatType: {
    id: null,
    name: '',
    slug: '',
    description: '',
  },
};
